module.exports = __webpack_public_path__ + "static/media/bremen-loyalty-trans.d237cb15.jpg";